module.exports = __webpack_public_path__ + "img/allianz-turkish-movie-01.5865c4da.jpg";